module.exports = __webpack_public_path__ + "static/media/canneptrade.d9b1e138.jpg";